import { trans } from "@mongez/localization";
import { FooterSectionContent } from "./FooterSectionContent";

type FooterColumnProps = {
  titleKey: string;
  type: "pages" | "contact" | "openingHours" | "socialMedia";
  items: any[];
};

export function FooterColumn({ titleKey, type, items }: FooterColumnProps) {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-primary-dark text-lg font-semibold">
        {trans(titleKey)}
      </h3>
      <FooterSectionContent type={type} items={items} />
    </div>
  );
}

